<template>
    <div id="app">
        <v-app id="inspire">
            <v-layout row wrap>
                <v-flex sx12>
                    <div class="text-xs-center">
                        <v-card-title class="headline font-weight-regular justify-center">
                        </v-card-title>
                    </div>
                </v-flex>
            </v-layout>
            <br>

            <v-container grid-list-md>
                <div>
                    <v-card-title class="title font-weight-black">My Account</v-card-title>
                </div>

                <v-layout>
                    <v-flex xs12 md9>
                        <v-card>
                            <v-card-title primary-title class="headline blue-grey darken-3 font-weight-medium white--text">
                                <div> <h3 class="title font-weight-black">PERSONAL PROFILE</h3></div>
                            </v-card-title>

                            <v-card-text v-if="user">
                                <v-flex xs12 class="font-weight-regular subheading"><b>Email : </b> {{user.email}} </v-flex>
                                <v-flex xs12 class="font-weight-regular subheading"><b>Name : </b> {{user.fullName}} </v-flex>
                                <v-flex xs12 class="font-weight-regular subheading"><b>Address : </b> {{user.address.brgy}} {{user.address.city}} {{user.address.state}}</v-flex>
                                <v-flex xs12 class="font-weight-regular subheading"><b>Mobile Number : </b>{{user.mobileNumber}} </v-flex>
                            </v-card-text>

                            <v-card-actions>
                                <v-btn flat color="orange" @click="openProfileDialog()">Update</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>

                <v-layout>
                    <v-flex xs12 md12 style="overflow: auto">
                        <v-card>
                            <v-card-title primary-title class="pa-2 headline blue-grey darken-3 font-weight-medium white--text">
                                <div> <h3 class="title font-weight-black pl-2">MOTORCYCLE PROFILE</h3></div>
                                <v-spacer></v-spacer> 
                                <v-btn color="deep-orange" dark  @click="openMotorcycleDialog()">Add Motorcycle</v-btn>
                            </v-card-title>

                            <v-data-table :headers="headers" :items="motorcycles" class="elevation-3" :hide-default-footer="true">    
                                <template v-slot:items="props">
                                    <td>{{ props.item.dealer }}</td>
                                    <td class="text-xs-left">{{ props.item.make }}</td>
                                    <td class="text-xs-left">{{ props.item.classification }}</td>
                                    <td class="text-xs-left">{{ props.item.model }}</td>
                                    <td class="text-xs-left">{{ props.item.yearModel }}</td>
                                        <td class="text-xs-left">{{ props.item.color }}</td>
                                    <td class="text-xs-left">{{ props.item.engineNumber }}</td>
                                    <td class="text-xs-left">{{ props.item.chassisNumber }}</td>
                                    <td class="text-xs-left">{{ props.item.plateNumber }}</td>
                                    <td class="text-xs-left">{{ props.item.odometer }}</td>
                                    <td class="text-xs-left">{{ props.item.dateOfPurchase }}</td>
                                    <td class="text-xs-left">{{ props.item.registrationDate }}</td>
                                    <td class="text-xs-center">
                                        <v-icon @click="viewHistory(props.item)">more_horiz</v-icon>
                                    </td>
                                </template> 
                            </v-data-table>
                        </v-card>
                    </v-flex>
                </v-layout> 
            </v-container>

            <v-dialog v-model="updateInfoDialog" persistent max-width="800px">
               <v-card>
                    <v-parallax dark class="blue-grey darken-4" height="70">
                        <v-container>
                            <v-layout>
                                <h4 class="subheading font-weight-medium">UPDATE PROFILE</h4>
                            </v-layout>
                        </v-container>
                    </v-parallax> 
                
                    <v-card-text>
                        <v-container grid-list-md class="pt-0">
                            <v-layout wrap>
                                <v-flex xs6>
                                    <v-flex xs12>
                                        <v-text-field v-model="firstName" hide-details label="First Name*"></v-text-field>
                                    </v-flex>

                                    <v-flex xs12>
                                        <v-text-field v-model="middleName" hide-details label="Middle Name"></v-text-field>
                                    </v-flex>

                                    <v-flex xs12>
                                        <v-text-field v-model="lastName" hide-details label="Last Name*"></v-text-field>
                                    </v-flex>

                                    <v-layout>
                                        <v-flex xs3>
                                            <v-text-field label="Country Code" hide-details readonly type="text" required value="+63" ></v-text-field>
                                        </v-flex>
                                        <v-flex xs9>
                                            <v-text-field v-model="mobileNumber" hide-details :rules="mobileChecker" label="Mobile Number*" maxlength="10" type="text" required hint=" ex.9123456789"></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>

                                <v-flex xs6>
                                    <v-flex xs12>
                                        <v-text-field v-model="address.brgy" hide-details label="Barangay*"></v-text-field>
                                    </v-flex>

                                    <v-flex xs12>
                                        <v-text-field v-model="address.city" hide-details label="City*"></v-text-field>
                                    </v-flex>

                                    <v-flex xs12>
                                        <v-text-field v-model="address.state" hide-details label="Province*"></v-text-field>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                        </v-container>
                        <v-layout justify-center>
                            <v-card-actions>
                                <v-btn dark color="red accent-4" @click="closeProfileDialog()">Close</v-btn>
                                <v-btn dark color="blue darken-4" @click="saveUserDetails()">Save</v-btn>
                            </v-card-actions>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <Snackbar v-model="snackbar.show" :type="snackbar.type" :message="snackbar.message" />
            <Progress v-model="progress.show" :message="progress.message" />
            <motorcycleComponent v-model="motorcycleComponent.show"/>
            <!-- <v-dialog v-model="newMcProfileDialog" persistent max-width="600px">
                <motorcycle-component></motorcycle-component>
            </v-dialog> -->
        </v-app>
    </div>
</template>

<script>

import firebase from "firebase"
import "../../node_modules/firebaseui/dist/firebaseui.css"
import { mapGetters, mapActions, mapState } from "vuex"
import { db } from '../main.js'
import _ from 'lodash'
import motorcycleComponent from './Motorcycle.vue'
import loginComponent from './Login.vue'
import profileComponent from './Profile.vue'
import Snackbar from './Snackbar.vue'
import Progress from './Progress.vue'
export default {
    components: {
        loginComponent,
        profileComponent,
        motorcycleComponent,
        Snackbar,
        Progress,
    },
    data: () => ({
    loaded: false,
    updateInfoDialog: false,
    newMcProfileDialog: false,
    motorcycles: [],
    mobileNumber: "",
    mobileChecker: [v => v.length == 10|| 'Mobile number must be valid'],
    address: {
        brgy : "",
        city : "",
        state : ""
    },
    tin: "",
    fullName: "",
    firstName: "",
    middleName: "",
    lastName: "",
    countryCode: "+63",
    headers: [
        { text: 'Dealer', sortable: false, value: 'dealer'},
        { text: 'Make', value: 'make',  sortable: false  },
        { text: 'Classification', value: 'classification',  sortable: false  },
        { text: 'Model', value: 'model',  sortable: false  },
        { text: 'Year', value: 'year',  sortable: false  },
        { text: 'Color', value: 'color',  sortable: false  },
        { text: 'Engine Number', value: 'engineNumber',  sortable: false  },
        { text: 'Chassis Number', value: 'chassisNumber',  sortable: false  },
        { text: 'Plate Number', value: 'plateNumber',  sortable: false  },
        { text: 'Mileage', value: 'odometer',  sortable: false  },
        { text: 'Date of Purchase', value: 'dateOfPurchase',  sortable: false  },
        { text: 'Registration Date', value: 'registrationDate',  sortable: false  },
        { text: 'More', value: 'name', align: 'center', sortable: false}
    ],
    region: "",
    city: "",
    province: "",
    barangay: "",
    customers: [],
    snackbar: {
        responseMessage: "",
        show: false,
        type: "success"
    },
    progress: {
        message: "",
        show: false,
    },
    motorcycleHistoryDialog: false,
    serviceHistory: [],
    selectedMotorcycle: {},
    forChangeMotorcycle: {},
    editMotorcyleDialog: false,
    motorcycleComponent: {
        show: false,
    },
}), 

    methods : {
        openMotorcycleDialog() {
            // this.$store.dispatch("setMotorcycle", true)
            // this.newMcProfileDialog = true
            this.motorcycleComponent.show = true
        },
        closeMotorcycleDialog() {
            // this.$store.dispatch("setMotorcycle", false)
            // this.newMcProfileDialog = false
             this.motorcycleComponent.show = true
        },
        openProfileDialog() {
            this.updateInfoDialog = true
        },
        closeProfileDialog() {
            this.updateInfoDialog = false
        },
        showSnackbarMessage(message, success = true) {
            this.snackbar.type = success ? "success" : "error"
            this.snackbar.message = message
            this.snackbar.show = true
        },
        showProgress(message) {
            this.progress.message = message
            this.progress.show = true
        },
        stopProgress() {
            this.progress.show = false
        },

        async fetchWalkin() {
			let self = this
            self.customers = []
            await db.collection("WalkinCustomers"+self.$stage)
			.where("status","==","Completed").get().then(function(snapshot) {
				snapshot.forEach(function(doc) {
					self.customers.push(doc.data())
				})
			}).catch(error => console.log(error))
		},

        async fetchMcDetails() {
            let self = this
            self.motorcycles = []
            if(self.user){
                db.collection("McDetails"+self.$stage)
                .onSnapshot(function(querySnapshot) {
                    self.motorcycles = []
                    querySnapshot.forEach(function(doc){
                        if(self.user.email==doc.data().email && doc.data().status=="1") {
                            self.motorcycles.push(doc.data())
                        }
                    })
                })
            } 
        },

        saveUserDetails() {
            let self = this
            let lists = []
            firebase.auth().onAuthStateChanged(function(user) {
                if(self.mobileNumber.length !== 10) {  
                    self.showSnackbarMessage("Please input valid mobile number", false)        
                } else if(self.firstName === "" || self.lastName === "") {
                    self.showSnackbarMessage("First name and last name should not be blank.", false)     
                } else if (self.address.brgy === "" || self.address.city === "" || self.address.state === "") {
                    self.showSnackbarMessage("Please enter your complete address. ", false) 
                } else {
                    self.showProgress("Updating Profile...") 
                    if (self.customers) {
                        self.customers = _.find(self.customers, {mobileNumber: self.mobileNumber})
                        if (self.customers) {
                            self.motorcycles = self.customers.motorcycles
                            db.collection('WalkinCustomers'+self.$stage)
                                .where('email','==',self.email)
                                .where('mobileNumber','==',self.mobileNumber)
                                .get().then(function(querySnapshot) {
                                querySnapshot.forEach(function(doc) {
                                    doc.ref.delete()
                                })
                            }).catch(error => console.log(error))
                        }
                    }

                    db.collection("Users"+self.$stage).doc(user.uid).update({
                        fullName: `${self.firstName} ${self.lastName}`,
                        firstName: self.firstName,
                        middleName: self.middleName,
                        lastName: self.lastName,
                        tin: "",
                        countryCode: self.countryCode,
                        mobileNumber: self.mobileNumber,
                        email: self.user.email,
                        address: self.address,
                    }).then(function(doc) {
                        firebase.auth().onAuthStateChanged(function(user) {
                            if (user) {
                                let googleUser = {
                                    uid: user.uid,
                                    email: user.email,
                                    displayName: user.displayName,
                                    photoURL: user.photoURL,
                                }
                                self.$store.dispatch("setUser", googleUser).then(() => {
                                    user.getIdToken().then(function(accessToken) {
                                        self.$store.dispatch("setToken", accessToken).then(() => {
                                            self.$store.dispatch("setAuth", true).then(() => {
                                                db.collection("Users"+self.$stage).doc(user.uid)
                                                .onSnapshot(function(doc) {
                                                    self.$store.dispatch("setRole", doc.data().role).then(() => {}).catch(error => console.log(error))
                                                })
                                            }).catch(error => console.log(error))
                                        })
                                    })
                                })
                            } 
                        }, function(error) { console.log(error) })
                        self.closeProfileDialog()
                        self.stopProgress()
                    })
                }
            })
        },

        viewHistory(mc) {
            let self = this
            self.$router.push(`service-history/${self.user.email}/${mc.model}`)
        },
    },

    mounted() {
        let self = this
        self.fetchWalkin()
        self.fetchMcDetails()
    },

    computed : {
        ...mapGetters(["user"],{
			regions: "Setup/regions",
			provinces: "Setup/provinces",
			cities: "Setup/cities",
			barangays: "Setup/barangays",
		}),
        ...mapState(["Auth"])
    },

    watch: {
        // Auth: {
        //     handler: function(newValue) {
        //         let self = this
        //         if (self.Auth.motorcycleComponent == true) {
        //             self.newMcProfileDialog = true
        //         } else {
        //             self.newMcProfileDialog = false
        //         }
        //     },
        //     deep: true
        // },
        region(value) {
			if (value) {
				this.$store.dispatch("Setup/getProvinces", {
					region: value,
				});
			}
		},
		province(value) {
			if (value) {
				this.$store.dispatch("Setup/getCities", {
					region: this.region,
					province: value,
				});
			}
		},
		city(value) {
			if (value) {
				this.$store.dispatch("Setup/getBarangays", {
					region: this.region,
					province: this.province,
					city: this.city,
				});
			}
		},
    }

}
</script>
